<template>
    <v-btn v-show="shows" v-bind="props_btn" color="primary" @click="go">
        <v-badge bordered v-bind="{ content }" color="error">
            <v-icon>mdi-gift-outline</v-icon>
        </v-badge>
    </v-btn>
</template>

<script>
import api from "@/api";

import FloatingActions from "./fab/floating-actions.vue";

export default {
    components: {
        FloatingActions,
    },
    props: {
        logon: { type: Boolean, default: false },
    },
    data: () => ({
        content: 0,
        intervalId: undefined,
    }),
    computed: {
        props_btn() {
            let props = {
                fixed: true,
                bottom: true,
                left: true,

                large: true,
                fab: true,
                icon: true,
                style: "box-shadow: 0 0 12px var(--shadow) !important;",
            };

            if (this.$vuetify.breakpoint.mobile) {
                return {
                    ...props,
                };
            }

            return {
                ...props,
            };
        },
        shows() {
            return this.logon && 0 < this.content;
        },
    },
    methods: {
        init() {
            this.intervalId = setInterval(this.search, 1000 * 5);
        },

        stop() {
            if (this.intervalId) clearInterval(this.intervalId);
        },

        async search() {
            if (!this.logon) return;

            let { summary } = await api.v1.me.gifts.gets({
                headers: { mode: "only-summary" },
                params: { type: "take", status: "발송" },
            });

            this.content = summary?.totalCount;
        },

        go() {
            this.$router.push("/mypage/cashes/gift?type=take");
        },

        play() {
            let audio = new Audio("/assets/alert.wav");
            audio.loop = false;
            audio.play();
        },
    },
    watch: {
        logon() {
            if (this.logon) this.init();
            else this.stop();
        },
        content() {
            if (0 < this.content) this.play();
        },
    },
    mounted() {
        if (this.logon) this.init();
    },
    beforeDestroy() {
        this.stop();
    },
};
</script>

<style></style>
